import {
  snapRound,
  type SnapRoundingOptions,
  SnapRoundingOptionsNone,
} from '@calculations/round/decimal';
import { Decimal } from '@snap-types/types/decimal';

export function calculateTotal(
  quantity: Decimal,
  unitValue: Decimal,
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsNone,
) {
  return snapRound(unitValue.times(quantity), roundingOptions);
}
